import { axiosClient } from "./axios";
import { API_ROUTES } from "../constants/apiRoutes";
import { ActiveESimResponse } from "../types/esim";

export interface GetEsimResponse {
  message: string;
  code: string;
  data: Data;
}

export interface Data {
  active: EsimDto[];
  expired: EsimDto[];
}

export interface EsimDto {
  msisdn: string;
  created_at: string;
  status_sim: string;
  package_name: string;
  img: string;
  active_stop: string;
}

export const getEsim = async (cusId: string): Promise<GetEsimResponse> => {
  const res = await axiosClient.get("/sim-profiles", {
    params: {
      cus_id: cusId,
    },
  });
  return res.data;
};

export const postActiveESim = async (
  msisdn: string
): Promise<ActiveESimResponse> => {
  const res = await axiosClient.post(`${API_ROUTES.ACTIVE_ESIM}`, {
    msisdn: msisdn,
  });
  return res.data;
};
